<template>
    <Modal :closable="!hasErrors" :ok="true" :okLabel="'Save & retry'" @ok="save" :padded-body="false">
        <template v-slot:header>Fix parser errors</template>
        <slot>
            <TextEditor v-model="blob" language="javascript" height="500"/>
        </slot>
    </Modal>
</template>

<script>
import Modal from '../components/Modal'
import TextEditor from '../components/TextEditor'
import {Events} from '../events'
import { RepositoryFactory } from '../data/RepositoryFactory'
const OHMRepository = RepositoryFactory.get('ohm')

export default {
    name: 'BlobEditor',
    components: { TextEditor, Modal },
    props: {
        link_filter_id: {
            default: null,
            type: Number
        },
        blob: {
            default: null,
            type: String
        },
        errors: {
            default: []
        }
    },
    mounted() {
        this.errors.forEach((e) => {
            Events.$emit('addError', {
                msg: e.msg,
                line_start: e.line_start,
                line_end: e.line_end,
                col_start: e.col_start,
                col_end: e.col_end
            })
        })
    },
    computed: {
        hasErrors() {
            return true
        }
    },
    methods: {
        save() {
            OHMRepository.saveBlob(this.blob, this.link_filter_id)
            .then((response) => {
                if (response.data) {
                    Events.$emit('addNotification', {
                        type: 'success',
                        msg: 'Saved hint blob, reloading...',
                        timeout: 3
                    })
                    window.location.reload()
                }
            }).catch((error) => {
                console.error(error)
                Events.$emit('addNotification', {
                    type: 'error',
                    msg: 'Failed to save hint blob',
                    timeout: 3
                })
            })
        }
    }
}
</script>
